import Logger from '../../../diagnostics/logging/logger';
import { cloneDeep } from 'lodash';

export const createCopyFixtureMenuItem = (props, node, gridId) => {
    const { group, data } = node;
    const title = 'Create new Fixture with Pos Info';

    return {
        name: title,
        action: () => {
            if (!group && data) {
                Logger.trackEvent(
                    'grid.context.copyFixtureWithPositionInfo',
                    gridId
                );

                const clonedData = cloneDeep(data);
                props.onCopyFixture(clonedData);
            }
        },
        tooltip: title,
    };
};
